import React from 'react';

export default () => {
    return(
        <p>Error pagina no encontrada</p>

    )
}